import { getInfoByType } from 'app/utils/utils';
import { Icon } from '../Icon';
import { OwnedTargetInfo, SnapshotData, TargetCatalogEntryInfo } from 'ais-facade-api/api';
import { useMemo } from 'react';
import { motionlessSpeed } from 'app/constants/_constants';
import { useAppSelector } from 'app/store/store';
import { getVesselFillOpacity } from 'app/helpers/getVesselFillOpacity';

interface Props {
  vessel?: TargetCatalogEntryInfo | SnapshotData | OwnedTargetInfo;
  size?: string;
  inProgressBar?: boolean;
}

export const VesselIcon = ({ vessel, size, inProgressBar }: Props) => {
  if (!vessel) return null;
  const mode = useAppSelector((state) => state.mapStateSlice.mode);
  const isHistoryOrPlaybackMode = mode === 'history' || mode === 'playback';
  const isAton =
    vessel &&
    (('registrySpecialType' in vessel && vessel.registrySpecialType === 'ATON') ||
      ('registryData' in vessel && vessel.registryData?.specialType === 'ATON'));

  const opacity = !isAton ? getVesselFillOpacity(vessel.t, isHistoryOrPlaybackMode) : '1';

  const getType = (): undefined | number => {
    if ('registryData' in vessel && vessel.registryData?.type) return vessel.registryData.type;
    undefined;
  };

  const speed: number | undefined = useMemo(() => {
    if ('sog' in vessel) {
      return vessel.sog;
    }

    if ('position' in vessel && typeof vessel.position?.sog === 'number') {
      return vessel.position.sog;
    }
  }, [vessel]);

  const shipColor = getInfoByType(getType())?.color;
  const special = window._env_?.SPECIAL ? JSON.parse(window._env_.SPECIAL) : null;

  const iconName = () => {
    if (special !== null && special.includes(vessel.mmsi)) {
      return 'aircraft';
    } else if (isAton) {
      return 'aton';
    } else if (!inProgressBar && vessel && typeof speed === 'number' && speed < motionlessSpeed) {
      return 'motionless-target';
    } else if (vessel.source === 'SATELLITE') {
      return 'satellite-target';
    } else {
      return 'terrestrial-target';
    }
  };

  return <Icon name={iconName()} size={size || '16px'} fillOpacity={opacity} color={shipColor} />;
};
